module.exports = __webpack_public_path__ + "img/magento-code-review.98efce0c.jpeg";